import { render } from "./ResumePaymentView.vue?vue&type=template&id=44065acf"
import script from "./ResumePaymentView.vue?vue&type=script&lang=js"
export * from "./ResumePaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__